import { Injectable } from '@angular/core';
import { PermissionsImportType } from 'src/assets/features/import-steps/import-titles';
import { ImporterService } from '../importer/importer.service';
import { PermissionService } from '../permission/permission.service';
@Injectable({
  providedIn: 'root'
})
export class MenuImportService {
  constructor(private importerService: ImporterService, private permissionService: PermissionService) {}

  importFile(type: string) {
    this.importerService.resolveImportType(type);
  }

  hasRight(type: string): boolean {
    return this.permissionService.hasPermission(PermissionsImportType[type]);
  }
}
